import { USER_ACTIONS } from '../../constants/actionTypes';

const initialState = {
  users: [],
  loading: false,
  error: null
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTIONS.FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case USER_ACTIONS.FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        error: null
      };
    case USER_ACTIONS.FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default userReducer;
